import {Box, HBox} from '../../../components/core/view';
import {MainScreens, TabScreens} from '@buncha/navigation/types';
import React, {useCallback} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import Browse from '@buncha/components/core/icon/Browse';
import ChecvronRight from '@buncha/components/core/icon/ChecvronRight';
import {CommonScreens} from '@buncha/common/navigation/types';
import H6Text from '@buncha/components/core/text/H6Text';
import {Modules} from '@buncha/utils/types';
import {TouchableOpacity} from 'react-native';
import {navigation} from '@buncha/config/navigation';
import {styles} from '../MainComponent/style';
import {useGetLocale} from '@buncha/localization/hooks';

const AssignShopperCTA = () => {
  const muliFont = useFontTheme('muli');
  const theme = useColorThemeType();
  const {title} = useGetLocale(Modules.profile, TabScreens.Profile) ?? {};

  const navigateToAssignShopper = useCallback(() => {
    navigation.navigate(MainScreens.Common, {
      screen: CommonScreens.AssignShopper,
    });
  }, []);

  return (
    <TouchableOpacity onPress={navigateToAssignShopper}>
      <Box style={styles.listContainer}>
        <HBox style={[styles.boxContainer, styles.assignOrderContainer]}>
          <Browse
            fill={theme?.text.gray[100]}
            width={24}
            height={24}
            viewBox="0 -3 24 24"
          />
          <HBox style={styles.boxContentContainer}>
            <H6Text
              style={[
                styles.listTypo,
                {
                  fontFamily: muliFont[700].normal,
                },
              ]}>
              {title?.assignOrder}
            </H6Text>
            <ChecvronRight viewBox="-7 -3 20 20" />
          </HBox>
        </HBox>
      </Box>
    </TouchableOpacity>
  );
};

export default React.memo(AssignShopperCTA);
